import { TIME_FORMATS } from '@config/index';
import { head } from 'lodash';
import { CompanyUtilService } from '../services';

import { IEvent } from '../types';

/**
 * get event sales start date time(UTC)
 *
 * @param event target event
 */
export const getEventSalesStartDateTime = (event: IEvent): string | null => {
  return head(event.event_days)?.start_date_time;
};

export const formatEventStartAndEndDateTime = (
  event: IEvent,
  options: {
    companyUtilService: CompanyUtilService;
  },
): string => {
  const { companyUtilService } = options;

  const eventStartDate = getEventSalesStartDateTime(event);
  const eventEndDate = head(event.event_days)?.end_date_time;

  const format = TIME_FORMATS.L_LT;

  const formattedStartDateTime = companyUtilService.convertUTCDateWithTimeZone(
    eventStartDate,
    true,
    format,
  );
  const formattedEndDateTime = companyUtilService.convertUTCDateWithTimeZone(
    eventEndDate,
    true,
    format,
  );

  return `${formattedStartDateTime} ~ ${formattedEndDateTime}`;
};
